import { Card } from "common/components/Card";
import { PrepStepContainer, PrepStepContent, PrepStepDescription, PrepStepTitle } from "prep/components/PrepElements";
import React from "react";
import { FormattedMessage } from "react-intl";
import { PREP_INSTRUCTIONS_PAGE_LABELS } from "./PrepInstructions.labels";
import { Checkbox, defaultTheme, Stack } from "common/components/ui";
import { Appearance, Space } from "common/components/ui/shared";
import Select from "@deliverr/react-select-v1";
import { LabelPlacement } from "./PrepInstructionsTypes";

export interface PrepInstructionsProps {
  isCoverLabelsChecked: boolean;
  handleCoverLabelsChange: () => void;
  handleLabelSelect: ({ value }: { value: any }) => void;
  labelPlacement: LabelPlacement | undefined;
  labelPlacementOptions: {
    label: string;
    value: LabelPlacement;
  }[];
}

export const PrepInstructions = (props: PrepInstructionsProps) => {
  const { isCoverLabelsChecked, handleCoverLabelsChange, handleLabelSelect, labelPlacement, labelPlacementOptions } =
    props;
  return (
    <PrepStepContainer>
      <Card>
        <PrepStepTitle>
          <FormattedMessage {...PREP_INSTRUCTIONS_PAGE_LABELS.title} />
        </PrepStepTitle>
        <PrepStepDescription appearance={Appearance.INFO}>
          <FormattedMessage {...PREP_INSTRUCTIONS_PAGE_LABELS.description} />
        </PrepStepDescription>
        <PrepStepContent>
          <Stack gap={Space.S8}>
            <Checkbox
              label={<FormattedMessage {...PREP_INSTRUCTIONS_PAGE_LABELS.labels.coverLabels} />}
              labelStyles={`color: ${defaultTheme.colors.NEUTRAL["500"]}`}
              onChange={handleCoverLabelsChange}
              checked={isCoverLabelsChecked}
            />
            <Select
              placeholder={<FormattedMessage {...PREP_INSTRUCTIONS_PAGE_LABELS.labels.selectLabelPlacement} />}
              options={labelPlacementOptions}
              onChange={handleLabelSelect}
              value={labelPlacement}
            />
          </Stack>
        </PrepStepContent>
      </Card>
    </PrepStepContainer>
  );
};
